/** Paper-toned splash shown while a stored session token is validated. */
export default function FullScreenLoader() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'grid',
        placeItems: 'center',
        gap: 0,
      }}
    >
      <div style={{ display: 'grid', placeItems: 'center', gap: 18 }}>
        {/* ⚠️ THE THIRD PLACEHOLDER STAR, AND THE ONE NOBODY WAS LOOKING FOR.
            Brian photographed the login screen; this splash carried the same
            hand-drawn star and was found by check-brand-assets.mjs rather than
            by eye. It shows while a stored session token is validated, so it is
            the first thing a returning rep sees — before the login screen.
            Dark chip removed for the same reason as the login seal: the real
            monogram is charcoal line-work on transparency. */}
        <img
          src="/brand/sr-monogram.png"
          alt=""
          aria-hidden="true"
          width="52"
          height="52"
          style={{ width: 52, height: 52, objectFit: 'contain', display: 'block' }}
        />
        <div className="spinner" aria-label="Loading" />
      </div>
    </div>
  )
}
